import { RESIDENTS_MOBILE_COLORS } from '@/constants/residents/mobile/color';

export const buildCenteredHeader = (title: string) => ({
  headerShown: true,
  headerTitle: title,
  headerBackTitleVisible: false,
  headerTitleAlign: 'center' as const,
  headerShadowVisible: false,
  headerTintColor: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
  headerStyle: {
    backgroundColor: RESIDENTS_MOBILE_COLORS.BACKGROUND_PRIMARY,
    shadowColor: 'transparent',
    elevation: 0,
    borderBottomWidth: 0,
  },
  headerTitleStyle: {
    fontSize: 15,
    fontWeight: '700' as const,
    fontFamily: 'System',
  },
});

export default buildCenteredHeader;

